import React from 'react';
import './AuthWarningModal.css';

/**
 * Auth Warning Modal
 * Displays when no refresh token is found in URL
 */
function AuthWarningModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className="auth-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="auth-modal-icon">⚠️</div>
        <h2 className="auth-modal-title">Authentication Required</h2>
        <p className="auth-modal-message">
          No refresh token found in the URL. Please access this application from the VIO Miniapp.
        </p>
        <button className="auth-modal-button" onClick={onClose}>
          Continue Anyway
        </button>
      </div>
    </div>
  );
}

export default AuthWarningModal;

